import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import PostDetails from "../components/PostDetails";
import CommentsTable from "../components/CommentsTable";
import CommentReplies from "../components/CommentReplies";
import { ApiUrl } from '../Constants/Weburl'
import Layout from "../components/Layout";

export default function PostView() {
  return (
    <div className="layout">
     
       <Layout>
        <div className="pv-grid">
          <PostDetails />
          <div className="commentstables">
          <CommentsTable />
          {/* <CommentReplies /> */}
          </div>
        </div>
        <div style={{margin:20}}>
        
        </div>

        </Layout>
      </div>
  
  );
}